import { Component, Input } from '@angular/core';
import { EventPin } from '@shared/interfaces/pins.interface';
import * as moment from 'moment/moment';

@Component({
    selector: 'app-map-infowindow-event',
    templateUrl: './map-infowindow-event.component.html'
})
export class MapInfoWindowEventComponent {
    @Input() pin: EventPin;
}
